import script from "./examFieldDesigner.vue?vue&type=script&setup=true&lang=js"
export * from "./examFieldDesigner.vue?vue&type=script&setup=true&lang=js"

import "./examFieldDesigner.vue?vue&type=style&index=0&id=536faa42&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-536faa42"]])

export default __exports__